<script>
    import { getContext } from "svelte";
    import { scale } from "svelte/transition";

    import { TOASTS_KEY } from "./toast.js";

    export let toast;

    const { removeToast } = getContext(TOASTS_KEY);

    $: timed = (toast.duration !== undefined);

    function handleDismiss() {
        removeToast(toast.id);
    }
</script>

<div class="root" style={`--duration: ${toast.duration}ms`} transition:scale={{ duration: 250, start: 0.8 }}>
    <div class="progress" class:timed on:animationend={handleDismiss} />
    <div class="content-container">
        <div class="content">
            {#if toast.escape}
                {toast.content}
            {:else}
                {@html toast.content}
            {/if}
        </div>
        <div class="separator" />
        <div class="dismiss" on:click={handleDismiss}>Dismiss</div>
    </div>
</div>

<style>
    .root {
        color: #fff;
        background-color: #2f458d;
        border-radius: 20px;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        position: relative;
    }

    .progress {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #25f;
        z-index: 5;
    }

    .progress.timed {
        animation-name: progress-width;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
        animation-duration: var(--duration);
        animation-play-state: running;
    }

    .root:hover .progress.timed {
        animation-play-state: paused;
    }

    @keyframes progress-width {
        from {
            width: 100%;
        }
        to {
            width: 0%;
        }
    }

    .content-container {
        display: grid;
        grid-template-rows: min-content;
        grid-template-columns: min-content 2px min-content;
        position: relative;
        z-index: 10;
    }

    .content {
        padding: 10px 15px 10px 20px;
    }

    .separator {
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .dismiss {
        padding: 10px 20px 10px 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dismiss:focus,
    .dismiss:hover {
        background-color: #fff;
        color: #25f;
    }
</style>
